import(/* webpackMode: "eager" */ "/workspace/app/thank-you/page.tsx");
